import { DoctorAssignedRooms, RoomDoctorData } from "../types/RoomDoctor";
import { UserData } from "../types/User";
import { patientApiUrl } from "./api";

const API_URL = "/RoomDoctors";

export const getData = async (): Promise<RoomDoctorData[]> => {
  try {
    const res = await patientApiUrl.get<RoomDoctorData[]>(API_URL);
    return res.data;
  } catch (error: any) {
    console.error(
      `Get room doctors error: ${
        error.response?.data?.message || error.message
      }`
    );
    return [];
  }
};

export const createData = async (
  userId: number,
  consultingRoomId: number
): Promise<RoomDoctorData | null> => {
  try {
    const res = await patientApiUrl.post<RoomDoctorData>(API_URL, {
      userId,
      consultingRoomId,
    });
    return res.data;
  } catch (error: any) {
    console.error(
      `Create room doctor error: ${
        error.response?.data?.message || error.message
      }`
    );
    return null;
  }
};

export const deleteData = async (
  userId: number,
  consultingRoomId: number
): Promise<boolean> => {
  try {
    await patientApiUrl.delete(`${API_URL}/${userId}/${consultingRoomId}`);
    return true;
  } catch (error: any) {
    console.error(
      `Delete room doctor error: ${
        error.response?.data?.message || error.message
      }`
    );
    return false;
  }
};

export function mapDoctorsToAssignedRooms(
  users: UserData[],
  roomDoctors: RoomDoctorData[],
  consultingRoomId: number
): DoctorAssignedRooms[] {
  return users.map((user, index) => {
    const assignedRoom = roomDoctors.find(
      (rd) => rd.userId === user.id && rd.consultingRoomId === consultingRoomId
    );

    return {
      id: assignedRoom?.id ?? index + 1,
      userId: user.id,
      consultingRoomId,
      fullName: `${user.firstName} ${user.middleName ?? ""} ${
        user.lastName
      }`.trim(),
      isAssigned: !!assignedRoom,
    };
  });
}
